import { Component, Input, OnInit, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { Observable, timer } from 'rxjs';
import { FormsModule, NgForm } from '@angular/forms';
import { BaseEditComponent } from "../../Services/BaseEditComponent";
import { FileUploader } from 'ng2-file-upload';
import { ConfigService } from "../../Services/ConfigService";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Component({
    selector: 'PopUpBusy',
    templateUrl: 'PopUpBusy.html',
    moduleId: module.id
})

export class PopUpBusyComponent implements OnInit, OnDestroy {

	sub: Subscription = null;
	ngOnDestroy() {
		if (this.sub) {
			this.sub.unsubscribe();
		}
	}
	ngOnInit() {
		try {
			// subscribing to a observable returns a subscription object
			this.sub = timer(1000, 1000).subscribe(() => {
				this.cnter++;
				if (this.cnter >= this.words.length) {
					this.cnter = 0;
				}
				this.BusyText = this.words[this.cnter];
			});
		} catch (err) {
			this.BusyText = this.words[this.cnter];
		}
	}

	cnter: number = 0;
	words: string[] = ['Working...', 'Searching...', 'Trying...', 'Giving it a go...'];

	BusyText: string = '';
    constructor(
        public configData: ConfigService,
		private activeModal: NgbActiveModal) {

		this.BusyText = this.words[this.cnter];
	}

	closePopUp(obj: any) {
		this.activeModal.close();
	}

	cancelOperation() {
		this.activeModal.close(true);
	}
}

